import React, { useRef } from 'react';
import styled from 'styled-components';
import AccordionBox from '@catalogo/ui-americanas-mobile-accordion-box-new';
import Download from '@catalogo/ui-americanas-desktop-svg/download.svg';

const DownloadIcon = styled(Download)`
  margin-left: 7px;
`;

const Link = styled.a`
  display: flex;
  align-items: center;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.primaryColor};
  }
`;

const LinkWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;
`;

const SpecsCell = styled.table`
  table-layout: fixed;
  width: 100%;
`;

const View = styled.tr`
  &:nth-of-type(odd) {
    background-color: #f2f2f2;
  }
`;

const Text = styled.td`
  padding: 10px;
  font: 14px Helvetica, Arial, Sans Serif;
  color: #666;
`;

export const createRow = (attribute, key) => (
  <View key={`${attribute.name}-${attribute?.value?.length + key}`}>
    <Text>{attribute.name}</Text>
    <Text>{attribute.value}</Text>
  </View>
);

export const containsValue = attibute => !!attibute?.value;

export const renderAtributes = (product, device) => {
  const id = product?.id;
  const attributes = product?.attributes ?? [];
  const eans = product?.skus?.[0]?.eans?.[0] || null;
  const customAttibutes = [
    { name: 'Código', value: id },
    { name: 'Código de barras', value: eans },
  ];
  return (
    <>
      {renderManual(product)}
      <SpecsCell device={device}>
        <tbody>
          {customAttibutes?.filter(containsValue).map(createRow)}
          {attributes?.map(createRow)}
        </tbody>
      </SpecsCell>
    </>
  );
};

const renderManual = product => {
  const manual = product?.manuals?.[0] ?? '';
  const isValidManual = manual.includes('.pdf');

  if (isValidManual) {
    return (
      <LinkWrapper>
        <Link href={manual} target="_blank">
          baixar manual de instruções
          <DownloadIcon width={15} height={15} fill="#666" aria-hidden="true" />
        </Link>
      </LinkWrapper>
    );
  }
};

export const SpecsDrawer = ({ product, page, match, history, device }) => {
  const ref = useRef(null);

  return (
    <AccordionBox
      ref={ref}
      title="Ficha Técnica"
      htmlElTitle="h2"
      shouldGetElementHeightOnRender={true}
      metricId="ficha técnica"
    >
      {renderAtributes(product, device)}
    </AccordionBox>
  );
};

export default SpecsDrawer;
